export const iconSize = 70;

export const defaultErrorMessage =
  'Oops, something went wrong. Please try again or contact info@marekhealth.com for help.';

export const loadingMessage =
  'Files are being uploaded from your device, this may take a moment. Do not close this window.';

export const successMessage =
  'Document submitted! Your physical exam form will be processed and verified within 72 hours.';
